export var JobType;
(function (JobType) {
    JobType["Service"] = "Service";
    JobType["Flow"] = "Flow";
})(JobType || (JobType = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["Queued"] = "queued";
    JobStatus["Starting"] = "starting";
    JobStatus["Started"] = "started";
    JobStatus["Failed"] = "failed";
    JobStatus["Finished"] = "finished";
    JobStatus["Skipped"] = "skipped";
    JobStatus["Cancelled"] = "cancelled";
})(JobStatus || (JobStatus = {}));
export const COMPLETED_JOB_STATUSES = [
    JobStatus.Failed,
    JobStatus.Finished,
    JobStatus.Skipped,
    JobStatus.Cancelled,
];
